export * from './translate.service';
export * from './translations';
export * from './translate.pipe';



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/translate/index.ts